<template>
    <div class="collapsible-scale" @transitionend="finalize">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "CollapsibleScale",
        props: {
            collapsed: {
                type: Boolean,
                default: () => false
            }
        },
        data() {
            return {
                collapsing: false
            };
        },
        watch: {
            collapsed: function (collapse) {
                if (collapse) {
                    this.hide();
                } else {
                    this.show();
                }
            }
        },
        mounted() {
            if (this.collapsed) {
                this.$el.classList.add('collapsed', 'closed');
            } else {
                this.$el.classList.remove('collapsed', 'closed');
            }
        },
        methods: {
            hide() {
                if (this.collapsing) {
                    return;
                }
                this.collapsing = true;
                let node = this.$el;
                node.classList.add("collapsed");
            },
            show() {
                if (this.collapsing) {
                    return;
                }
                this.collapsing = true;
                let node = this.$el;
                node.classList.remove('closed');
                this.reflow();
                node.classList.remove("collapsed");
            },
            reflow() {
                return this.$el.offsetHeight;
            },
            finalize() {
                if (this.collapsing) {
                    this.collapsing = false;
                    if (this.collapsed) {
                        this.$el.classList.add('closed');
                    }
                    this.$emit('update', !this.collapsed);
                }
            }
        }
    }
</script>

<style lang="postcss">
    .collapsible-scale {
        transition: transform 0.5s ease;
        transform: scaleY(1);
        transform-origin: top;
        overflow: hidden;
        &.collapsed {
            transform: scaleY(0);
        }
        &.closed {
            display: none;
        }
    }
</style>
